// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__container___N18Vi {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-bottom: var(--section-margin-bottom);
}

.styles__link___oWzXV {
    display: inline-block;
    width: 220px;
}

.styles__link___oWzXV img {
    display: block;
    width: 100%;
}

@media screen and (min-width: 768px) {
    .styles__container___N18Vi {
        gap: 30px;
    }
}
`, "",{"version":3,"sources":["webpack://./../../shared/components/StoreLinks/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,2CAA2C;AAC/C;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI;QACI,SAAS;IACb;AACJ","sourcesContent":[".container {\n    display: flex;\n    justify-content: center;\n    gap: 40px;\n    margin-bottom: var(--section-margin-bottom);\n}\n\n.link {\n    display: inline-block;\n    width: 220px;\n}\n\n.link img {\n    display: block;\n    width: 100%;\n}\n\n@media screen and (min-width: 768px) {\n    .container {\n        gap: 30px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles__container___N18Vi`,
	"link": `styles__link___oWzXV`
};
export default ___CSS_LOADER_EXPORT___;
